export default __webpack_public_path__ + "static/media/Labs-at-your-home.890549af.svg";